/** @format */

import { combineReducers } from "redux";
// import mode from "./mode";
import auth from "./auth";
import role from "./role";
import setting from "./setting";
import locale from "./locale";
import RtkQueryService from "src/services/RtkQueryService.js";

// Define static reducers
const staticReducers = {
  auth,
  setting,
  locale,
  role,
  [RtkQueryService.reducerPath]: RtkQueryService.reducer,
};

// Combine reducers function
const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
